import React, { FC, useState } from 'react';
import { CopiedIcon, StripeIcon } from '../../assets/icons';
import { useAppDispatch, useAppSelector } from '../../redux/store';
import { Alert, Button, Modal, Spinner } from '../../components/shared';
import { getBookingLink } from '../../redux/features/bookings/bookingsSlice';

interface TableActionsProps {
  restProps: any;
  recallList?: any;
}

export const Children: FC<TableActionsProps> = ({ restProps, recallList }) => {
  // REDUX STATES & ACTIONS
  const dispatch = useAppDispatch();
  const { linkLoading: loading, linkError: error } = useAppSelector(state => state?.allBookings);
  // STATES
  const [isOpenStripeModal, setIsOpenStripeModal] = useState(false);
  const [stripeLink, setStripeLink] = useState<string>('');
  const [isError, setIsError] = useState<boolean>(false);
  const [isSuccess, setIsSuccess] = useState<boolean>(false);
  const [successMessage, setSuccessMessage] = useState<string>('');
  const [isCopied, setIsCopied] = useState(false);

  const handleCreateStripe = async () => {
    setIsError(false);
    setIsSuccess(false);
    const data = await dispatch(getBookingLink({ bookingId: restProps?.row?.completeItem?._id }));
    if (data.meta.requestStatus === 'rejected') {
      setIsError(true);
    }
    if (data.meta.requestStatus === 'fulfilled') {
      setStripeLink(data?.payload?.data?.url);
      setIsSuccess(true);
      setSuccessMessage(data.payload?.message);
    }
  };

  //HANDLE COPY LINK
  const onClickOpenLink = () => {
    if (stripeLink) {
      window.open(stripeLink, '_blank');
      onClose();
    }
  };

  const onClickCopyLink = () => {
    if (window) {
      window.navigator.clipboard.writeText(stripeLink).then(res => {
        setIsCopied(true);
        setTimeout(() => {
          setIsCopied(false);
        }, 1000);
      });
    }
  };

  const onClose = () => {
    setIsOpenStripeModal(false);
    setSuccessMessage('');
    setIsError(false);
    setIsSuccess(false);
    recallList();
  };

  return (
    <React.Fragment>
      <div className='flex flex-col'>
        {/* Reset  Password Link */}
        <button
          className='hover:cursor-pointer transition-all duration-300 rounded-[4px] hover:bg-gray-200 p-2 flex items-center gap-2'
          onClick={() => {
            setIsOpenStripeModal(true);
            handleCreateStripe();
          }}
        >
          <StripeIcon className='w-[20px] h-[20px]' />
          Stripe Link
        </button>
      </div>

      {/* Stripe Account Modal */}
      <Modal
        open={isOpenStripeModal}
        onClose={() => {
          setIsOpenStripeModal(false);
          onClose();
        }}
        title='Stripe Account Link'
        icon={<StripeIcon className='w-[20px] h-[20px]' />}
      >
        <div className='mt-4 '>
          {loading ? (
            <Spinner width='w-8' height='h-8' border='border-[4px]' />
          ) : (
            isSuccess && (
              <div className='flex  items-center gap-2'>
                <p
                  className='text-[1rem] leading-relaxed max-w-96 truncate bg-gray-200 rounded hover:text-[#3362DA] p-1 cursor-pointer'
                  onClick={onClickOpenLink}
                >
                  {stripeLink}
                </p>
                {isCopied && (
                  <span className='absolute left-[420px] top-[50px] p-[2px] rounded'>Copied</span>
                )}
                <CopiedIcon
                  className='w-[20px] h-[20px] cursor-pointer'
                  onClick={onClickCopyLink}
                />
              </div>
            )
          )}
          <Alert
            color={isError ? 'danger' : isSuccess ? 'success' : 'danger'}
            text={
              isError ? (error ? error : 'Something went wrong') : isSuccess ? successMessage : null
            }
            showAlert={isError || isSuccess}
            // onClose={onClose}
            isShowClose={isSuccess ? false : true}
          />
        </div>
        <div className='flex justify-end gap-2 mt-4'>
          <Button variant='secondary' color='' onClick={onClose}>
            Close
          </Button>
        </div>
      </Modal>
    </React.Fragment>
  );
};
